import * as fromPaymentMethod from '@app/store/actions/payment-methods.action';
import { PaymentMethod } from '@vestiaire/api-sdk-angular/model/paymentMethod';

export interface IPaymentMethods {
  paymentMethods: PaymentMethod[];
}

export function reducer(state: any, action: fromPaymentMethod.PaymentMethodsActions) {
  switch (action.type) {
    case fromPaymentMethod.SET_PAYMENT_METHOD:
      return { ...state, paymentMethods: action.payload };
    default:
      return state;
  }
}
